import { TrackJS } from 'trackjs';

export default () => {
    TrackJS.install({ token: "5a875745440e4260ace12ea39c98afee" });
}